export const SORT_DIRECTION = { ascending: "asc", descending: "desc" };
